
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7S9uM", function(module, exports) {

var $gw4Eo = parcelRequire("gw4Eo");

const $4578b5a9386fb739$export$7159abb8d1b3a2ba = (eventName)=>`avi:confluence:${eventName}`;
const $4578b5a9386fb739$export$c08b254487aa335f = (resourceId)=>{
    if (Array.isArray(resourceId)) return resourceId;
    else return [
        resourceId
    ];
};
const $4578b5a9386fb739$export$2bf1e957d474f961 = (client)=>{
    return client?.currentProtocol?.getType();
};
class $4578b5a9386fb739$export$7f942edeee9c7437 {
    /**
   * @param {object} client
   * @param {string} cloudId
   * @param {string} activationId
   */ constructor(client, cloudId, activationId){
        this.client = void 0;
        this.cloudId = void 0;
        this.activationId = void 0;
        /**
     * Join a channel
     * @param {array|string} resourceType - string represents the type of resource: page, comment, blogpost, space
     * @param {array|string} resourceId - multiple or a resource id
     */ this.joinChannel = async (resourceType, resourceId)=>{
            const resourceIds = $4578b5a9386fb739$export$c08b254487aa335f(resourceId);
            const aris = resourceIds.map((id)=>(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: this.cloudId,
                    resourceType: resourceType,
                    activationId: this.activationId,
                    resourceId: id
                }));
            return this.client.join(aris).catch((error)=>{
                throw new Error(`PubSub Web Client (${$4578b5a9386fb739$export$2bf1e957d474f961(this.client)}) joinChannel
        ${JSON.stringify(error, Object.getOwnPropertyNames(error))} aris: ${aris}`);
            });
        };
        /**
     * Leave a channel
     * @param {array|string} resourceId - multiple or a resource id
     */ this.leaveChannel = async (resourceType, resourceId)=>{
            const resourceIds = $4578b5a9386fb739$export$c08b254487aa335f(resourceId);
            const aris = resourceIds.map((id)=>(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: this.cloudId,
                    resourceType: resourceType,
                    activationId: this.activationId,
                    resourceId: id
                }));
            return this.client.leave(aris).catch((error)=>{
                throw new Error(`PubSub Web Client (${$4578b5a9386fb739$export$2bf1e957d474f961(this.client)}) leaveChannel
        ${JSON.stringify(error, Object.getOwnPropertyNames(error))} aris: ${aris}`);
            });
        };
        /**
     * Subscribe to an event being broadcast in channel
     * @param {array|string} eventName - name of event to subscribe to
     */ this.subscribe = async (eventName, cb)=>{
            return this.subscribeSync(eventName, cb);
        };
        this.subscribeSync = (eventName, cb)=>{
            return this.client.on(eventName, cb);
        };
        /**
     * Unsubscribe from an event being broadcast in channel
     * @param {array|string} eventName - name of event to subscribe to
     */ this.unsubscribe = async (eventName, cb)=>{
            return this.unsubscribeSync(eventName, cb);
        };
        this.unsubscribeSync = (eventName, cb)=>{
            return this.client.off(eventName, cb);
        };
        this.client = client;
        this.cloudId = cloudId;
        this.activationId = activationId;
    }
}
module.exports["eventToAvi"] = $4578b5a9386fb739$export$7159abb8d1b3a2ba;
module.exports["getCurrentProtocolType"] = $4578b5a9386fb739$export$2bf1e957d474f961;
module.exports["PubSubClient"] = $4578b5a9386fb739$export$7f942edeee9c7437;

});

parcelRegister("gRrX4", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $7S9uM = parcelRequire("7S9uM");

const $25943768104c0291$var$CONFLUENCE_PRODUCT_KEY = 'CONFLUENCE';
// Where the pubsub service lives
const $25943768104c0291$var$PUBSUB_HOST = '/gateway/api/pubsub';
let $25943768104c0291$var$pubsubClientPromise;
const $25943768104c0291$var$getPubSubDevUrl = ()=>{
    if (window.location.hostname === 'localhost' && true) {
        // In dev mode this allows the local dev proxy to use the WebSocket host
        // that matches the backend origin host. The __backendOriginHost is only
        // available with local dev server.
        const host = window.__backendOriginHost;
        return new URL('/gateway/wss/fps', `wss://${host}`);
    }
    return undefined;
};
const $25943768104c0291$export$45a69314cf48a3eb = ({ url: url, analyticsClient: analyticsClient })=>{
    return {
        product: $25943768104c0291$var$CONFLUENCE_PRODUCT_KEY,
        url: url,
        apsProtocol: {
            enabled: true,
            url: $25943768104c0291$var$getPubSubDevUrl()
        },
        analyticsClient: analyticsClient
    };
};

const $25943768104c0291$export$d77c15f0d624f8d2 = ()=>{
    return (0, $ge2sX.getSessionData)().then(async ({ cloudId: cloudId, activationId: activationId })=>{
        const analyticsClient = await (0, $04e9M.getAnalyticsWebClient)();
        const config = $25943768104c0291$export$45a69314cf48a3eb({
            url: $25943768104c0291$var$PUBSUB_HOST,
            analyticsClient: analyticsClient
        });
        return (parcelRequire("70D4t")).then((module)=>{
            const Client = module.default;
            return new (0, $7S9uM.PubSubClient)(new Client(config), cloudId, activationId);
        }).catch((error)=>{
            throw new Error(`PubSub--Current Web Client ${error}, ${JSON.stringify({
                ...config
            })}`);
        });
    });
};
const $25943768104c0291$export$e390a4d8bc17ac24 = ()=>{
    if ($25943768104c0291$var$pubsubClientPromise) return $25943768104c0291$var$pubsubClientPromise;
    $25943768104c0291$var$pubsubClientPromise = $25943768104c0291$export$d77c15f0d624f8d2();
    return $25943768104c0291$var$pubsubClientPromise;
};
module.exports["getPubSubClient"] = $25943768104c0291$export$e390a4d8bc17ac24;

});

parcelRegister("70D4t", function(module, exports) {

let $51a6d73b0c61f183$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $51a6d73b0c61f183$var$load("jryxA"),
    $51a6d73b0c61f183$var$load("dWZbK"),
    $51a6d73b0c61f183$var$load("fZyYv")
]).then(()=>parcelRequire('7PP2u'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("kmyZQ", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");



var $9wGTI = parcelRequire("9wGTI");


var $1ps47 = parcelRequire("1ps47");

class $766713eeaff568b4$export$91fd6e064cf0bcf3 extends (0, $T1bCI.Container) {
    getInitialStatus(state) {
        if (state) return state.status;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = window.__SSR_RENDERED__;
        if (isSSR && (0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) {
            // window.__SSR_IS_LIVE_PAGE__ only works in hydration after SSR, so need to use ssr-inputs when its in SSR mode to get the live page data.
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            const isLivePageSSR = (0, window.__SSR_IS_LIVE_PAGE__);
            if (isLivePageSSR) return 'RESET';
        }
        return isSSR ? 'SSR' : 'RESET';
    }
    constructor(state){
        super();
        this.exitAnimationTimer = void 0;
        this.delayedAnimationTimer = void 0;
        this.timeoutTimer = void 0;
        /**
     * There are race conditions where we try to start too soon after resetting,
     * with the result being that state is not yet updated and the start fails.
     * This class property is a hack used to circumvent that behavior.
     */ this.recentlyReset = false;
        /**
     * isStarting is used for handling a race condition.
     * When a page is cached, start() and finish() are fired simultaneously.
     * In start() function, setState({ status: "START" }) is async,
     * so when finish() is invoked, status haven't been set to "START" yet.
     */ this.isStarting = false;
        this.isStopping = false;
        this.prevMatch = null;
        this.isRunning = ()=>(this.state.status === 'START' || this.isStarting) && !this.isStopping;
        this.isDelayed = ()=>this.state.status === 'DELAYED';
        this.hasStarted = ()=>this.isRunning() || this.isDelayed();
        this.isStartable = ()=>this.state.status === 'RESET' || this.state.status === 'SSR' || this.recentlyReset;
        this.getStatus = ()=>{
            return this.state.status;
        };
        this.getDuration = ()=>{
            return this.state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION);
        };
        /**
     * The progress bar start to move.
     */ this.start = (duration = (0, $1ps47.DEFAULT_LOADING_DURATION), timeoutDuration = (0, $1ps47.TIMEOUT_TIMER))=>{
            if (!this.isStartable()) return Promise.resolve();
            this.recentlyReset = false;
            this.isStarting = true;
            /**
       * If the progress bar has started, and haven't received a finish signal within ${DEFAULT_LOADING_DURATION}ms,
       * render shimmer and linear-gradient effect.
       */ this.delayedAnimationTimer = setTimeout(()=>{
                if (!this.isRunning()) return;
                this.setState({
                    status: 'DELAYED'
                });
            }, duration);
            /**
       * If the progress bar has started, and haven't received a finish signal within ${TIMEOUT_TIMER}ms,
       * hide the progress bar, and reset the data.
       */ this.timeoutTimer = setTimeout(()=>{
                if (!this.isDelayed()) return;
                this.reset();
            }, timeoutDuration);
            return this.setState({
                status: 'START',
                duration: duration
            }, ()=>{
                this.isStarting = false;
            });
        };
        /**
     * Trigger the progress bar to move to the end quickly.
     */ this.finish = ()=>{
            if (!(this.isRunning() || this.isDelayed())) return;
            this.isStopping = true;
            let promise;
            if (this.isDelayed()) promise = this.reset();
            else {
                this.isStarting = false;
                promise = this.setState({
                    status: 'FINISH'
                }, ()=>{
                    this.isStopping = false;
                });
            }
            this.exitAnimationTimer = setTimeout(()=>{
                this.reset();
            }, (0, $1ps47.POST_FINISHED_IDLE_DURATION));
            return promise;
        };
        /**
     * Hide the progress bar and reset the data.
     */ this.reset = ()=>{
            clearTimeout(this.exitAnimationTimer);
            clearTimeout(this.delayedAnimationTimer);
            clearTimeout(this.timeoutTimer);
            const promise = this.setState({
                status: 'RESET'
            });
            this.recentlyReset = true;
            this.isStopping = false;
            return promise;
        };
        this.state = {
            status: this.getInitialStatus(state),
            duration: state && state.duration || (0, $1ps47.DEFAULT_LOADING_DURATION)
        };
    }
}
module.exports["ProgressBarContainer"] = $766713eeaff568b4$export$91fd6e064cf0bcf3;

});

parcelRegister("1ps47", function(module, exports) {
const $91d046db84f1ff20$export$3aa7f8be29c3e9b0 = 'progressStyles';
const $91d046db84f1ff20$export$5724a8f791ebaa77 = 'global-progress-bar';
const $91d046db84f1ff20$export$53d51cc6d57e44da = "var(--ds-background-brand-bold, #1868DB)";
const $91d046db84f1ff20$export$5412169de0facc6c = 300;
const $91d046db84f1ff20$export$899393f3e23f724b = 6000;
const $91d046db84f1ff20$export$7868b416d8929c55 = 20000;
const $91d046db84f1ff20$export$55cff6338bbd9ca8 = $91d046db84f1ff20$export$5412169de0facc6c + 50;
module.exports["NAV4_ID"] = $91d046db84f1ff20$export$3aa7f8be29c3e9b0;
module.exports["NAV3_ID"] = $91d046db84f1ff20$export$5724a8f791ebaa77;
module.exports["DEFAULT_LOADING_BAR_COLOR"] = $91d046db84f1ff20$export$53d51cc6d57e44da;
module.exports["EXIT_ANIMATION_SPEED"] = $91d046db84f1ff20$export$5412169de0facc6c;
module.exports["DEFAULT_LOADING_DURATION"] = $91d046db84f1ff20$export$899393f3e23f724b;
module.exports["TIMEOUT_TIMER"] = $91d046db84f1ff20$export$7868b416d8929c55;
module.exports["POST_FINISHED_IDLE_DURATION"] = $91d046db84f1ff20$export$55cff6338bbd9ca8;

});

parcelRegister("bT0se", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $04e9M = parcelRequire("04e9M");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gRrX4 = parcelRequire("gRrX4");


var $7S9uM = parcelRequire("7S9uM");

const $521819119d35ee54$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error'
];
const $521819119d35ee54$var$isIgnoredPubSubError = (error)=>{
    return $521819119d35ee54$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString));
};
const $521819119d35ee54$export$eee20638634729b3 = (eventName, onEvent)=>{
    return (...args)=>{
        onEvent(...args);
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent({
                action: 'received',
                actionSubject: 'pubsub.event',
                actionSubjectId: eventName,
                source: 'usePubSubEvent'
            });
        }, ()=>{});
    };
};
const $521819119d35ee54$export$db1c585708735fff = ({ contentId: contentId, contentType: contentType, eventName: eventName, onEvent: onEvent, attribution: attribution, skip: skipProp = false })=>{
    const [pubSubClient, setPubSubClient] = (0, $42omo.useState)(undefined);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    // if user is anonymous, skip
    const skip = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || skipProp;
    (0, $42omo.useEffect)(()=>{
        if (skip || !contentId || !contentType) return;
        const pubSubPromise = new Promise((resolve)=>{
            (0, $gRrX4.getPubSubClient)().then((psc)=>{
                psc.joinChannel(contentType, contentId).then(()=>{
                    setPubSubClient(psc);
                    // Temporarily fire events when PubNub protocol is detected
                    // to investigate source of requests
                    if ((0, $7S9uM.getCurrentProtocolType)(psc.client) === 'pubnub') {
                        const { analyticsClient: analyticsClient, ...config } = psc.client?.config;
                        // copy config obj so we can scrub URL from logs
                        const configCopy = JSON.parse(JSON.stringify(config));
                        delete configCopy.apsProtocol?.url;
                        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                            client.sendOperationalEvent({
                                action: 'using.pubnub',
                                actionSubject: 'client',
                                source: 'usePubSubEvent',
                                attributes: {
                                    contentId: contentId,
                                    contentType: contentType,
                                    config: configCopy
                                }
                            });
                        });
                    }
                    resolve(psc);
                }).catch((error)=>{
                    if (!$521819119d35ee54$var$isIgnoredPubSubError(error)) {
                        const e = new Error(`PubSub (${(0, $7S9uM.getCurrentProtocolType)(psc.client)}) - failed to join channel - ${error} - ${eventName}`);
                        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                            attribution: attribution || (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                        });
                    }
                });
            });
        });
        return ()=>{
            pubSubPromise.then((psc)=>{
                setPubSubClient(undefined);
                psc.leaveChannel(contentType, contentId);
            });
        };
    }, [
        contentType,
        contentId,
        attribution,
        skip,
        eventName
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!pubSubClient) return;
        const avi = (0, $7S9uM.eventToAvi)(eventName);
        const eventHandler = $521819119d35ee54$export$eee20638634729b3(avi, onEvent);
        try {
            pubSubClient.subscribeSync(avi, eventHandler);
        } catch (error) {
            const e = new Error(`PubSub (${(0, $7S9uM.getCurrentProtocolType)(pubSubClient.client)}) - failed to subscribe to ${eventName} - ${error}`);
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: attribution || (0, $3IBnw.Attribution).PAGE_EXTENSIONS
            });
        }
        return ()=>{
            pubSubClient.unsubscribeSync(avi, eventHandler);
        };
    }, [
        pubSubClient,
        eventName,
        onEvent,
        attribution
    ]);
};
module.exports["usePubSubEvent"] = $521819119d35ee54$export$db1c585708735fff;

});

var $0e213fe6f9f13a91$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2F69B\",\"vendors~small-pkgs.53e052c9.js\",\"fZyYv\",\"pubsub.31effd76.js\",\"dWZbK\",\"emoji.255bbff3.js\",\"jryxA\",\"emoji.runtime.630c8448.js\",\"jryxA\",\"emoji.runtime.630c8448.js\"]"));


$parcel$global.rlb("2F69B")
//# sourceMappingURL=vendors~small-pkgs.53e052c9.js.map
